<script>

import moment from "moment";

export default {
  setup() {
    return {  };
  },
  components: {

  },
  props: {
    projetosList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },

  mounted() {
    // console.log('mounted projetos-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CO':
          result = 'Concluído'
          break
        case 'CA':
          result = 'Cancelado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.$router.push(`/projeto/editar/${dataID}`)
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {



    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="projetosList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Cliente</th>
        <th class="align-middle">Tipo</th>
        <th class="align-middle">Data</th>
        <th class="align-middle text-end">Prior.</th>
        <th class="align-middle text-end">Prior. Dia</th>
        <th class="align-middle">Gestor</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in projetosList" :key="data.id">
        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>
        <td>{{ data.codigo }} </td>
        <td>{{ data.descricao }} </td>
        <td>{{ data.cliente }} </td>
        <td>{{ data.tipo }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td>{{ data.priorid }} </td>
        <td>{{ data.priodia }} </td>
        <td>{{ data.gestor }} </td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'AB' ? 'badge-soft-warning' :
                  data.status === 'CO' ? 'badge-soft-success' :
                  'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>


  </div>

</template>
